import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { UserPen } from "lucide-react";
import Select from "react-select";
import moment from "moment-jalaali";

import { useAuth } from "../context/AuthContext";
import UserService from "../services/userService";

import "react-multi-date-picker/styles/layouts/mobile.css";

export default function DashboardProfile() {
  const { user, setUser } = useAuth();

    const navigate = useNavigate();
  const location = useLocation();

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  /*
   * ----------------------------------------
   * Birthday
   * ----------------------------------------
   */

  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedDay, setSelectedDay] = useState(null);

  /*
   * ----------------------------------------
   * Form
   * ----------------------------------------
   */

  const [form, setForm] = useState({
    userId: "",
    name: "",
    lname: "",
    introduced: "",
    phone: "",
    mobile: "",
    gender: "",
    birtday: "",
    email: "",
    social: "",
  });

  /*
   * ----------------------------------------
   * Birthday options
   * ----------------------------------------
   */

  const days = Array.from({ length: 31 }, (_, i) => ({
    value: i + 1,
    label: String(i + 1),
  }));

  const months = [
    { value: 1, label: "فروردین" },
    { value: 2, label: "اردیبهشت" },
    { value: 3, label: "خرداد" },
    { value: 4, label: "تیر" },
    { value: 5, label: "مرداد" },
    { value: 6, label: "شهریور" },
    { value: 7, label: "مهر" },
    { value: 8, label: "آبان" },
    { value: 9, label: "آذر" },
    { value: 10, label: "دی" },
    { value: 11, label: "بهمن" },
    { value: 12, label: "اسفند" },
  ];

  const currentShamsiYear = 1405;

  const years = Array.from({ length: 100 }, (_, i) => ({
    value: currentShamsiYear - i,
    label: String(currentShamsiYear - i),
  }));

  /*
   * ----------------------------------------
   * Load user into form
   * ----------------------------------------
   */

  useEffect(() => {
       if (!user) {
         console.log('Login Erorrrrrr Profile');
      // navigate("/login", {
      //   state: {
      //     from: location.pathname + location.search,
      //   },
      // });

      // return;
    }

    setForm({
      userId: user.id || "",
      name: user.name || "",
      lname: user.lname || "",
      introduced: user.introduced || "",
      phone: user.phone || "",
      mobile: user.mobile || "",
      gender: user.gender ?? "",
      birtday: user.birtday || "",
      email: user.email || "",
      social: user.social || "",
    });

    /*
     * Convert Gregorian DB date
     * to Persian date for the selects.
     */
    if (user.birtday) {
      const jDate = moment(
        user.birtday,
        "YYYY-MM-DD"
      );

      setSelectedYear(
        Number(jDate.format("jYYYY"))
      );

      setSelectedMonth(
        Number(jDate.format("jM"))
      );

      setSelectedDay(
        Number(jDate.format("jD"))
      );
    } else {
      setSelectedYear(null);
      setSelectedMonth(null);
      setSelectedDay(null);
    }
  }, [user]);

  /*
   * ----------------------------------------
   * Select styles
   * ----------------------------------------
   */

  const isMobile = window.innerWidth <= 992;

  const selectStyle = {
    control: (base, state) => ({
      ...base,

      width: isMobile ? "100%" : "150px",

      height: 54,
      minHeight: 54,

      borderRadius: 12,

      borderColor: state.isFocused
        ? "#95b73c"
        : "#d1d5db",

      boxShadow: state.isFocused
        ? "0 0 0 4px rgba(190, 230, 142, 0.12)"
        : "none",

      color: "#696969",

      "&:hover": {
        borderColor: "#95b73c",
      },
    }),

    option: (base, state) => ({
      ...base,

      backgroundColor: state.isSelected
        ? "#95b73c"
        : state.isFocused
          ? "#ecfdf5"
          : "#fff",

      color: state.isSelected
        ? "#fff"
        : "#333",

      cursor: "pointer",
    }),

    valueContainer: (base) => ({
      ...base,

      height: 54,

      padding: "0 12px",
    }),

    input: (base) => ({
      ...base,

      margin: 0,
      padding: 0,

      color: "#696969",
    }),

    indicatorsContainer: (base) => ({
      ...base,

      height: 54,
    }),

    placeholder: (base) => ({
      ...base,

      color: "#696969",
      fontSize: 15,
    }),

    singleValue: (base) => ({
      ...base,

      fontSize: 15,
      color: "#696969",
    }),
  };

  /*
   * ----------------------------------------
   * Form change
   * ----------------------------------------
   */

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((previous) => ({
      ...previous,
      [name]: value,
    }));

    /*
     * Clear validation error when
     * user starts editing the field.
     */
    if (errors[name]) {
      setErrors((previous) => {
        const newErrors = { ...previous };

        delete newErrors[name];

        return newErrors;
      });
    }
  };

  /*
   * ----------------------------------------
   * Build birthday
   * ----------------------------------------
   *
   * We keep the three Persian values because
   * your Laravel API already receives:
   *
   * day
   * month
   * year
   */

  const buildBirthday = () => {
    if (
      !selectedYear ||
      !selectedMonth ||
      !selectedDay
    ) {
      return "";
    }

    return `${selectedYear}-${String(
      selectedMonth
    ).padStart(2, "0")}-${String(
      selectedDay
    ).padStart(2, "0")}`;
  };

  /*
   * ----------------------------------------
   * Update profile
   * ----------------------------------------
   */

  const updateProfile = async (e) => {
    e.preventDefault();

    if (!user?.id) {
      toast.error("کاربر یافت نشد.");

      return;
    }

    setLoading(true);
    setErrors({});

    const birthday = buildBirthday();

    const payload = {
      name: form.name?.trim() || "",
      lname: form.lname?.trim() || "",
      introduced: form.introduced?.trim() || "",
      phone: form.phone?.trim() || "",
      mobile: form.mobile || "",
      gender: form.gender || "",

      birtday: birthday,

      /*
       * Keep these because your Laravel
       * controller currently receives them.
       */
      day: selectedDay,
      month: selectedMonth,
      year: selectedYear,

      email: form.email?.trim() || "",
      social: form.social?.trim() || "",
    };

    try {
      const data =
        await UserService.updateProfile(
          user.id,
          payload
        );

      /*
       * IMPORTANT:
       *
       * AuthContext is now the source of truth.
       *
       * This automatically updates:
       *
       * ProfileSidebar
       * UserMiniPanel
       * DashboardProfile
       */
      if (data?.user) {
        setUser(data.user);
      }

      toast.success(
        data?.message ||
          "اطلاعات با موفقیت ذخیره شد."
      );

    } catch (error) {
      console.error(
        "Update profile error:",
        error
      );

      /*
       * Laravel validation error
       */
      if (error.response?.status === 422) {
        const validationErrors =
          error.response.data?.errors || {};

        setErrors(validationErrors);

        /*
         * Show first validation error
         */
        const firstError = Object.values(
          validationErrors
        )[0];

        if (firstError?.[0]) {
          toast.error(firstError[0]);
        }

        return;
      }

      /*
       * User not found
       */
      if (error.response?.status === 404) {
        toast.error("کاربر یافت نشد.");

        return;
      }

      /*
       * Unauthorized
       */
      if (error.response?.status === 401) {
        toast.error(
          "نشست شما منقضی شده است. لطفاً دوباره وارد شوید."
        );

        return;
      }

      /*
       * Server error
       */
      if (error.response?.status >= 500) {
        toast.error(
          "خطایی در سرور رخ داده است."
        );

        return;
      }

      /*
       * Network / unknown error
       */
      toast.error(
        "ارتباط با سرور برقرار نشد."
      );
    } finally {
      setLoading(false);
    }
  };

  /*
   * ----------------------------------------
   * Validation helper
   * ----------------------------------------
   */

  const getError = (field) => {
    return errors[field]?.[0] || "";
  };

  /*
   * ----------------------------------------
   * No user
   * ----------------------------------------
   */

      if (!user) {
        console.log('Login Erorrrrrr');
      // navigate("/login", {
      //   state: {
      //     from: location.pathname + location.search,
      //   },
      // });

      // return;
    }
  /*
   * ----------------------------------------
   * Render
   * ----------------------------------------
   */

  return (
    <div className="register-page">

      <div className="wrapper">

        <div className="register-card">

          <h2>
            <span>
              اطلاعات و مشخصات کاربری
            </span>
          </h2>

          <form
            className="register-form"
            onSubmit={updateProfile}
            autoComplete="off"
          >

            {/* ==========================
                First Name
            =========================== */}

            <div className="form-group">

              <input
                id="firstName"
                name="name"
                type="text"
                placeholder=" "
                value={form.name}
                onChange={handleChange}
                autoComplete="new-password"
              />

              <label htmlFor="firstName">
                نام
              </label>

              {getError("name") && (
                <small className="field-error">
                  {getError("name")}
                </small>
              )}

            </div>


            {/* ==========================
                Last Name
            =========================== */}

            <div className="form-group">

              <input
                id="lastName"
                name="lname"
                type="text"
                placeholder=" "
                value={form.lname}
                onChange={handleChange}
                autoComplete="new-password"
              />

              <label htmlFor="lastName">
                نام خانوادگی
              </label>

              {getError("lname") && (
                <small className="field-error">
                  {getError("lname")}
                </small>
              )}

            </div>


            {/* ==========================
                Introduced
            =========================== */}

            <div className="form-group">

              <input
                id="introduced"
                name="introduced"
                type="text"
                placeholder=" "
                value={form.introduced}
                onChange={handleChange}
                autoComplete="new-password"
              />

              <label htmlFor="introduced">
                کد معرف
              </label>

              {getError("introduced") && (
                <small className="field-error">
                  {getError("introduced")}
                </small>
              )}

            </div>


            {/* ==========================
                Mobile
            =========================== */}

            <div className="form-group">

              <input
                className="readonly-input"
                id="mobile"
                type="text"
                placeholder=" "
                value={form.mobile}
                readOnly
              />

              <label htmlFor="mobile">
                شماره موبایل
              </label>

            </div>


            {/* ==========================
                Phone
            =========================== */}

            <div className="form-group">

              <input
                id="phone"
                name="phone"
                type="text"
                placeholder=" "
                value={form.phone}
                onChange={handleChange}
                autoComplete="new-password"
              />

              <label htmlFor="phone">
                شماره تلفن
              </label>

              {getError("phone") && (
                <small className="field-error">
                  {getError("phone")}
                </small>
              )}

            </div>


            {/* ==========================
                Gender
            =========================== */}

            <div className="gender-field">

              <div className="gender-title">
                جنسیت
              </div>

              <div className="gender-options">

                <label className="gender-option">

                  <input
                    type="radio"
                    name="gender"
                    value="1"
                    checked={
                      String(form.gender) === "1"
                    }
                    onChange={handleChange}
                  />

                  <span className="gender-circle"></span>

                  <span className="gender-text">
                    آقا
                  </span>

                </label>


                <label className="gender-option">

                  <input
                    type="radio"
                    name="gender"
                    value="0"
                    checked={
                      String(form.gender) === "0"
                    }
                    onChange={handleChange}
                  />

                  <span className="gender-circle"></span>

                  <span className="gender-text">
                    خانم
                  </span>

                </label>

              </div>

              {getError("gender") && (
                <small className="field-error">
                  {getError("gender")}
                </small>
              )}

            </div>


            {/* ==========================
                Birthday
            =========================== */}

            <div className="birth-date">

              <Select
                styles={selectStyle}
                options={days}
                value={
                  days.find(
                    (d) =>
                      d.value === selectedDay
                  ) || null
                }
                onChange={(option) =>
                  setSelectedDay(
                    option?.value || null
                  )
                }
                placeholder="روز"
                isSearchable
                isClearable
              />


              <Select
                styles={selectStyle}
                options={months}
                value={
                  months.find(
                    (m) =>
                      m.value === selectedMonth
                  ) || null
                }
                onChange={(option) =>
                  setSelectedMonth(
                    option?.value || null
                  )
                }
                placeholder="ماه"
                isSearchable
                isClearable
              />


              <Select
                styles={selectStyle}
                options={years}
                value={
                  years.find(
                    (y) =>
                      y.value === selectedYear
                  ) || null
                }
                onChange={(option) =>
                  setSelectedYear(
                    option?.value || null
                  )
                }
                placeholder="سال"
                isSearchable
                isClearable
              />

            </div>


            {/* ==========================
                Email
            =========================== */}

            <div className="form-group">

              <input
                id="email"
                name="email"
                type="email"
                placeholder=" "
                value={form.email}
                onChange={handleChange}
                disabled={
                  form.email?.trim().length > 0
                }
                autoComplete="new-password"
              />

              <label htmlFor="email">
                ایمیل
              </label>

              {getError("email") && (
                <small className="field-error">
                  {getError("email")}
                </small>
              )}

            </div>


            {/* ==========================
                Social
            =========================== */}

            <div className="form-group">

              <input
                id="social"
                name="social"
                type="text"
                placeholder=" "
                value={form.social}
                onChange={handleChange}
                autoComplete="new-password"
              />

              <label htmlFor="social">
                شبکه اجتماعی
              </label>

              {getError("social") && (
                <small className="field-error">
                  {getError("social")}
                </small>
              )}

            </div>


            {/* ==========================
                Update
            =========================== */}

            <div className="form-group-update">

              <button
                type="submit"
                disabled={loading}
              >

                {loading ? (
                  <>
                    <span className="loader"></span>

                    <span>
                      در حال ذخیره...
                    </span>
                  </>
                ) : (
                  <>
                    <UserPen
                      size={24}
                      color="#ffffff"
                      strokeWidth={1.5}
                    />

                    <span>
                      بروزرسانی اطلاعات
                    </span>
                  </>
                )}

              </button>

            </div>

          </form>

        </div>

      </div>

    </div>
  );
}